export default {
  yellow: '#FFE500',
  lightYellow: '#FFF067',
  green: '#00FFA3',
  red: '#FF3981',
  blue: '#4DFFFF',
  black: '#000000',
  white: '#FFFFFF',
  greys: {
    veryDark: '#2D2D2D',
    dark: '#464646',
    medium: '#414141',
    mediumLight: '#686868',
    light: '#737373',
    lighter: '#F3F3F3',
    veryLight: '#FCFCFC',
  },
}
